/**
 * Cenários de inspeção das telas. Só valem no modo mock (`VITE_USE_MOCKS=true`):
 * em produção a fase vem da API e o parâmetro `?cenario=` é ignorado.
 */
export const DEMO_SCENARIOS = [
  { value: 'normal', label: 'Uso normal' },
  { value: 'carregando', label: 'Carregando' },
  { value: 'vazio', label: 'Lista vazia' },
  { value: 'erro', label: 'Erro ao carregar' },
  { value: 'sem-permissao', label: 'Sem permissão' },
  { value: 'nao-contratado', label: 'Módulo não contratado' },
] as const;

export type DemoScenario = (typeof DEMO_SCENARIOS)[number]['value'];

export function isDemoScenario(value: string | null): value is DemoScenario {
  return DEMO_SCENARIOS.some((item) => item.value === value);
}
